import axios from './../index';
const {
  get,
  post,
  put,
  del,
  getStream
} = axios;
const saasBusinessUrl = "/saas-business";
const domain = window.location.host.indexOf('localhost') == -1 ? window.location.origin : 'http://hxkht.rel-s.yunduoketang.cn';
export function checkFaceVerify(params) {
  // 获取人脸识别参数
  return get(`${saasBusinessUrl}/companyFaceVerify/check?domain=${domain}`, params);
}
export function getFaceVerifyUrl(params) {
  // 获取腾讯URL
  return get(`${saasBusinessUrl}/companyFaceVerify/getFaceVerifyUrl?domain=${domain}`, params);
}
export function updateIdentity(params) {
  // 姓名与身份证号完善
  return post(`${saasBusinessUrl}/companyFaceVerify/updateIdentity?domain=${domain}`, params);
}
export function getResult(params) {
  // 姓名与身份证号完善
  return post(`${saasBusinessUrl}/companyFaceVerify/getResult?domain=${domain}&orderNo=${params.orderNo}`, params);
}